import React, { useState } from 'react';
import { Modal } from 'antd';
import { ModalProps } from 'antd/lib/modal';

import IrvScheduleTable, { IrvScheduleTableProps } from './IrvScheduleTable';
import { AssetFutureValueResponse } from 'services/assets';

export type IrvScheduleModalProps = Pick<ModalProps, 'onCancel' | 'visible'> &
  IrvScheduleTableProps & {
    controller?: React.ReactElement;
    currcode?: string;
    listContextFV?: AssetFutureValueResponse[];
  };

const IrvScheduleModal = ({
  irvSchedule = [],
  listContextFV = [],
  currcode,
  controller,
  onCancel: onCancelProp,
  visible: visibleProp,
  ...otherProps
}: IrvScheduleModalProps) => {
  const [visible, setVisible] = useState(false);

  return (
    <>
      {controller &&
        React.cloneElement(controller, { onClick: () => setVisible(true) })}

      <Modal
        title="Irv schedule"
        footer={null}
        width={1200}
        style={{ top: '20px', height: '400px' }}
        visible={controller ? visible : visibleProp}
        onCancel={controller ? () => setVisible(false) : onCancelProp}
        {...otherProps}
      >
        <IrvScheduleTable
          listContextFV={listContextFV}
          irvSchedule={irvSchedule}
          currcode={currcode}
        />
      </Modal>
    </>
  );
};

export default IrvScheduleModal;
